import React,{Component} from 'react'
import { Spin } from 'antd';



export default class Loading extends Component{
    render(){
        return(
            <div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh',background: 'rgba(0,0,0,0.7)'}}>
            <Spin size="large"/>
       </div>
        )
    }
}